import type { InvestableBucket } from "@/engine/types";

export const BUCKET_ORDEN: InvestableBucket[] = ["Preservación", "Ingreso", "Crecimiento"];
export const BUCKET_ICONO: Record<InvestableBucket, string> = { Preservación: "🛡", Ingreso: "💰", Crecimiento: "📈" };
export const BUCKET_COLOR: Record<InvestableBucket, string> = { Preservación: "var(--viz-pres)", Ingreso: "var(--viz-inc)", Crecimiento: "var(--viz-growth)" };
export const FUERA_COLOR = { personal: "var(--viz-personal)", business: "var(--viz-business)", contribution: "var(--viz-contrib)" } as const;
export const FUERA_ETIQUETA = { personal: "Uso personal", business: "Negocio y otros", contribution: "Contribución" } as const;
